import { useLocation } from 'react-router-dom';
import {
  useRefreshUnreadMessageCountAfterReading,
  useRefreshUnreadMessageCountOnThreadsChange,
} from 'hooks/use-unread-message-count/use-unread-message-count.hook';

/**
 * Refreshes the unread count once a thread is read and once the member leaves
 * the messaging screens. Renders nothing.
 *
 * It exists to hold the router subscription rather than let the nav bar hold it.
 * The page around the nav re-renders on every navigation, and the nav is
 * memoized so it does not have to follow; reading the location in the nav itself
 * would give it a reason to re-render on every navigation after all, taking the
 * whole header with it. A context subscription still reaches a consumer inside a
 * memoized parent, so keeping it here confines the re-render to a component with
 * no output.
 */
export const UnreadMessageCountRefresher = () => {
  useRefreshUnreadMessageCountAfterReading(useLocation().pathname);
  useRefreshUnreadMessageCountOnThreadsChange();
  return null;
};
